import {
  Flex,
  Button,
  FlexColumn,
  Breadcrumbs,
  SearchField,
} from '@elementary/common-ui/components';
import useSearchParams from '@elementary/common-ui/hooks/useSearchParams';
import { GROUP_ID, NEW_VALUE } from '@elementary/common-ui/constants/urlParams';
import useAccount from '@elementary/common-ui/hooks/useAccount';

interface HeaderProps {
  search: string;
  onSearchChange: (value: string) => void;
}

const Header = ({ search, onSearchChange }: HeaderProps) => {
  const [, setSearchParams] = useSearchParams();
  const { data: accountData } = useAccount();

  return (
    <FlexColumn sx={{ gap: 3 }}>
      <Breadcrumbs items={['Account', 'Groups']} showTreeButton={false} />
      <Flex sx={{ gap: 1, justifyContent: 'space-between' }}>
        <SearchField
          sx={{ width: '248px' }}
          onChange={(e) => onSearchChange(e.target.value)}
          value={search}
        />
        {/* 
        Limiting group creation to account without SCIM configuration.
        This is not due to a technical limitation, but rather a product decision.
        If that decision changes, this condition can be safely removed.
        */}
        {!accountData?.has_scim_configuration && (
          <Button
            sx={{ minWidth: '142px' }}
            onClick={() =>
              setSearchParams((prev) => {
                prev.set(GROUP_ID, NEW_VALUE);
                return prev;
              })
            }
          >
            Create group
          </Button>
        )}
      </Flex>
    </FlexColumn>
  );
};

export default Header;
